import TextInput from '../../../../TextInput/TextInput';
import React from 'react';
import './index.scss';
import ActionButtons from './ActionButtons';
import { useQueryBuilder } from '../context/QueryBuilderContext';
import { FILTER_OPERATORS } from '../../../utils/constants';

interface TextDropdownProps {
  closeDropdown: () => void;
  field: string;
  
}

const TextDropdown: React.FC<TextDropdownProps> = ({ field, closeDropdown }) => {
  const [value, setValue] = React.useState<string>('');
  const { setCondition, getConditionValue, removeCondition } = useQueryBuilder();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const applyFilter = () => {
    if (value.trim()) {
      setCondition(field, FILTER_OPERATORS.CONTAINS, value);
    } else {
      removeCondition(field);
    }
    closeDropdown();
  };

  const clearAll = () => {
    setValue('');
  };

  React.useEffect(() => {
    const condition = getConditionValue(field);
    if (condition?.[FILTER_OPERATORS.CONTAINS]) {
      setValue(condition?.[FILTER_OPERATORS.CONTAINS]);
    }
  }, [field, getConditionValue]);

  return (
    <div className="text-filter-dropdown">
      <TextInput
        testId={`am-v2-space-assets-filters-textDropdown-${field}`}
        onChange={handleChange}
        placeholder={'Enter text..'}
        type="text"
        version="v2"
        width="large"
        value={value}
        willBlurOnEsc
        autoFocus
      />
      <ActionButtons
        closeDropdown={closeDropdown}
        clearAll={clearAll}
        applyFilter={applyFilter}
      />
    </div>
  );
};

export default TextDropdown;
